<template>
  <div class="icons-box">
    <font-awesome-icon :icon="['fal', 'edit']"
                       :class="`icons-box__icon ${editShow ? '' : '-hidden'}`"
                       @click="$emit('editRoom')"/>
    <font-awesome-icon :icon="['fal','trash-alt']"
                       :class="`icons-box__icon ${trashShow ? '' : '-hidden'}`"
                       @click="$emit('deleteRoom')"/>
    <font-awesome-icon :icon="['fal', 'plus-square']"
                       class="icons-box__icon  icons-box__icon--addRoom"
                       @click="$emit('addRoom')"/>
  </div>
</template>
<script>
export default {
  name: 'iconBox',
  props: {
    trashShow: Boolean,
    editShow: Boolean,
  },
};
</script>
<style scoped lang="scss">
.icons-box {
  align-self: center;
  margin: 0 10px;
  display: flex;
  justify-content: center;
  align-content: center;
  .-hidden {
    visibility: hidden;
  }
  &__icon {
    display: grid;
    height: 26px;
    cursor: pointer;
    margin: 0 4px;
    &--addRoom{
      padding-top: 1.9px;
    }
  }
}
</style>
